import React from 'react';

function Loading() {
  return (
    <div className="loading">
      <div className="spinner">
        <div className="bounce1" />
        <div className="bounce2" />
        <div className="bounce3" />
      </div>
    </div>
  );
}

export default Loading;



// WEBPACK FOOTER //
// ./src/common/components/Loading.js